import { render, staticRenderFns } from "./TodoListItemSkeleton.vue?vue&type=template&id=43064a3d&scoped=true"
import script from "./TodoListItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./TodoListItemSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43064a3d",
  null
  
)

export default component.exports